"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var resource_1 = require("../shared/resource");
var Location = /** @class */ (function (_super) {
    __extends(Location, _super);
    function Location() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selected = false;
        return _this;
    }
    Location.prototype.url = function (action) {
        return '/locations/' + this.id + '/' + action;
    };
    Location.prototype.filterOptions = function (options) {
        options = lodash_1.clone(options);
        if (this.archived) {
            var _option = lodash_1.find(options, { action: 'archive' });
            if (_option) {
                lodash_1.remove(options, _option);
            }
        }
        if (!this.archived) {
            var _option = lodash_1.find(options, { action: 'unarchive' });
            if (_option) {
                lodash_1.remove(options, _option);
            }
        }
        return options;
    };
    return Location;
}(resource_1.Resource));
exports.Location = Location;
